<template>
  <index />
</template>

<script>
import Index from '@/components/views/index'

export default {
  name: 'App',
  components: { Index }
}
</script>

<style scoped></style>
